export default {
  'global.no.conection.message':
    'Vui lòng bật kết nối mạng Wi-Fi hoặc dữ liệu di động và thử lại sau',
  'global.no.conection.title': 'Không có kết nối mạng',
  'global.no.error.title': 'Lỗi',
  'global.button.close': 'Đóng',
};
